// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary-button {
    padding: 10px 18px;
    border: none;
    border-radius: 60px;
    color: black;
    background-color: #FD7272;
    cursor: pointer;
}

.green {
    padding: 10px 18px;
    border: none;
    border-radius: 60px;
    color: black;
    background-color: #3bed64;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/button/button.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,eAAe;AACnB","sourcesContent":[".primary-button {\n    padding: 10px 18px;\n    border: none;\n    border-radius: 60px;\n    color: black;\n    background-color: #FD7272;\n    cursor: pointer;\n}\n\n.green {\n    padding: 10px 18px;\n    border: none;\n    border-radius: 60px;\n    color: black;\n    background-color: #3bed64;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
